import React, { FunctionComponent } from 'react'
import { Heading, Icon, Text } from '@afterpaytouch/core'

import styles from './styles.module.css'
import spacing from './spacing.module.css'
import { TitleWithBody } from '..'
import { AssetChildComponentSpacing } from './types'
import { getSpacingClassName } from './helper'
import clsx from 'clsx'

interface Props extends AssetChildComponentSpacing {
  label?: string | TitleWithBody[]
  selected?: string
  show?: boolean
}

export const ThankYou: FunctionComponent<Props> = ({ label, show = false, selected = '', margin, marginBottom, marginTop }) => {
  if (!show || typeof label === 'undefined' || selected.trim().length === 0) {
    return null
  }

  if (Array.isArray(label) && label.length > 0) {
    const articleStyles = clsx(styles.thankyou, spacing.margin3xBottom, getSpacingClassName({ margin, marginBottom, marginTop }))

    return (
      <>
        {label.map((l, index) => (
          <article className={articleStyles} key={`postcheckout-${index}-answered`}>
            <div className={styles.primaryTitle}>
              <Heading size='M' renderAs='span' bold testNameSpace='postcheckout-answered'>
                {l.title}
              </Heading>
            </div>
            <Text>{l.body}</Text>
          </article>
        ))}
      </>
    )
  }

  if (typeof label === 'string') {
    const labelStyle = clsx(spacing.margin2xBottom, getSpacingClassName({ margin, marginBottom, marginTop }))
    return (
      <>
        <div className={labelStyle}>
          <Heading size='S' renderAs='span' bold testNameSpace='postcheckout-answered'>
            {label}
          </Heading>
        </div>
        <Icon.Verified /> <Text renderAs='span'>{selected}</Text>
      </>
    )
  }

  return null
}
